export default __webpack_public_path__ + "images/IO.f0de256.png";